






































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";
import Direccion from "@/models/direccion.model";
import BaseVue from "@/core/BaseVue";

@Component
export default class DireccionCollapse extends BaseVue {
  @Prop() public whereParams!: string;
  @Prop() public value!: number | any;
  @Prop() public title!: string;
  @Prop() public hideRef!: boolean;
  @Prop() public hideSeeMap!: boolean;
  @Prop() public showDesc!: boolean;
  @Prop() public showLatLon!: boolean;

  loading = false;
  initModel = new Direccion();
  direccion = this.map<Direccion>(this.initModel);
  client = new BaseRepository<Direccion>("direccion");

  showingMap = false;
  get isId() {
    return !isNaN(this.value);
  }

  async getDataAsync() {
    try {
      this.loading = true;
      if (this.value && this.isId) {
        let where = String();
        let include =
          "Region|Provincia|Municipio|DistritoMunicipal|Seccion|Barrio";
        if (this.whereParams) where += `id=${this.value}`;
        else where = `id=${this.value}`;

        this.direccion = await this.client.one(where, include);
      } else {
        this.direccion = this.value;
      }
      this.$emit("change", this.direccion);
    } catch (e) {
      this.direccion = this.map<Direccion>(this.initModel);
      this.$emit("change", null);
      this.operationFailedErrors(e);
    } finally {
      this.loading = false;
    }
  }

  @Watch("value", { deep: true, immediate: true })
  OnValueChange(value: any) {
    if (!value) {
      this.direccion = this.map<Direccion>(this.initModel);
      this.$emit("change", null);
      return;
    }
    this.getDataAsync();
  }

  close() {
    this.direccion = this.map<Direccion>(this.initModel);
    this.$emit("close", null);
    this.$emit("change", null);
  }
}
